__turbopack_context__.v({
  "change_station_button": "ChangeStationButton-module-scss-module__hhQC9G__change_station_button",
  "gear_icon": "ChangeStationButton-module-scss-module__hhQC9G__gear_icon",
});
